/* SCS Video Modal — Click video thumbnail to open YouTube embed in overlay */
(function() {
  // Create modal DOM
  var modal = document.createElement('div');
  modal.className = 'scs-video-modal';
  modal.id = 'scs-video-modal';
  modal.innerHTML = '<button class="close-video" aria-label="Close">&times;</button><div class="scs-video-modal__content"></div>';
  document.body.appendChild(modal);

  var content = modal.querySelector('.scs-video-modal__content');
  var closeBtn = modal.querySelector('.close-video');

  function openModal(videoUrl) {
    // YouTube embed URL
    var embedUrl = videoUrl;
    if (videoUrl.includes('youtube.com/embed/')) {
      embedUrl = videoUrl + '?autoplay=1&rel=0';
    }
    content.innerHTML = '<iframe width="100%" height="100%" src="' + embedUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="max-width:90vw;max-height:80vh;width:900px;height:506px;border-radius:12px;"></iframe>';
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('active');
    content.innerHTML = '';
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  // Global function called by video_item onclick
  window.scsPlayVideo = function(el) {
    var videoUrl = el.getAttribute('data-video');
    if (videoUrl) openModal(videoUrl);
  };
})();
